// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"bo-z","slideIn":"co-z"};